import { render, staticRenderFns } from "./bankcashbookdetail.vue?vue&type=template&id=000ab84c&scoped=true"
import script from "./bankcashbookdetail.vue?vue&type=script&lang=js"
export * from "./bankcashbookdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000ab84c",
  null
  
)

export default component.exports